module.exports = __webpack_public_path__ + "c99cd8b9e76ebb5aa73b927dd77e141a.svg";